import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../config/config";
import { useAuth } from '../../login/AuthContext';
import {
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  Grid,
  Paper,
} from "@mui/material";

const ModulesStep = ({ selectedPackage, selectedModules = [], onChange, isDisabled }) => {
  const { token } = useAuth();
  const [availableModules, setAvailableModules] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (selectedPackage?.PaketId) {
      fetchAvailableModules();
    } else {
      setAvailableModules([]);
    }
  }, [selectedPackage]);

  // Seçili ek modüller OrderForm tarafından yönetilir.
  // Burada müşteri/sipariş modüllerini tekrar çekip onChange ile ezme;
  // aksi halde kullanıcı seçimi / güncelleme kaybolur.

  const fetchAvailableModules = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${config.baseURL}/paket-detaylari/${selectedPackage.PaketId}/modul`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const modulesList = response.data.map((item) => ({
        id: item.ModuleId,
        name: item.Programlar.split(",")
      }));
      setAvailableModules(modulesList.flatMap(module =>
        module.name.map(name => ({
          id: module.id,
          name,
          ProgramId: module.id,
          EkModul: true
        })))
      );
    } catch (error) {
      console.error("Ek modüller alınamadı:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const sameModuleId = (a, b) => Number(a) === Number(b);

  const toggleModule = (moduleId, moduleName) => {
    let updatedModules = [...selectedModules];
    const isSelected = updatedModules.some(
      (m) => sameModuleId(m.id, moduleId) || sameModuleId(m.ProgramId, moduleId)
    );

    if (isSelected) {
      updatedModules = updatedModules.filter(
        (m) => !sameModuleId(m.id, moduleId) && !sameModuleId(m.ProgramId, moduleId)
      );
      if (
        (sameModuleId(moduleId, 1009) || sameModuleId(moduleId, 2010)) &&
        !updatedModules.some(
          (m) =>
            sameModuleId(m.id, 1009) ||
            sameModuleId(m.id, 2010) ||
            sameModuleId(m.ProgramId, 1009) ||
            sameModuleId(m.ProgramId, 2010)
        )
      ) {
        updatedModules = updatedModules.filter(
          (m) => !sameModuleId(m.id, 1011) && !sameModuleId(m.ProgramId, 1011)
        );
      }
    } else {
      updatedModules.push({
        id: moduleId,
        ProgramId: moduleId,
        name: moduleName,
        EkModul: true
      });

      if (sameModuleId(moduleId, 1009) || sameModuleId(moduleId, 2010)) {
        const module1011 = availableModules.find((m) => sameModuleId(m.id, 1011));
        if (
          module1011 &&
          !updatedModules.some(
            (m) => sameModuleId(m.id, 1011) || sameModuleId(m.ProgramId, 1011)
          )
        ) {
          updatedModules.push({
            id: 1011,
            ProgramId: 1011,
            name: module1011.name,
            EkModul: true
          });
        }
      }
    }

    onChange("modules", updatedModules);
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={100}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {availableModules.length > 0 ? (
        <Grid container spacing={2}>
          {availableModules.map((module, index) => {
            const isAutoSelected =
              sameModuleId(module.id, 1011) &&
              selectedModules.some(
                (m) =>
                  sameModuleId(m.id, 1009) ||
                  sameModuleId(m.id, 2010) ||
                  sameModuleId(m.ProgramId, 1009) ||
                  sameModuleId(m.ProgramId, 2010)
              );

            return (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={index}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "100%",
                    opacity: isDisabled ? 0.7 : 1,
                    position: 'relative'
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedModules.some(
                          (m) =>
                            sameModuleId(m.id, module.id) ||
                            sameModuleId(m.ProgramId, module.id)
                        )}
                        onChange={() => toggleModule(module.id, module.name)}
                        disabled={isDisabled || isAutoSelected}
                      />
                    }
                    label={
                      <Box>
                        <Typography variant="body2">
                          {module.name}
                        </Typography>
                        {isAutoSelected && (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block' }}
                          >
                            (E-Dönüşümde Zorunludur)
                          </Typography>
                        )}
                      </Box>
                    }
                  />
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Typography variant="body1">Ek modül bulunmamaktadır.</Typography>
      )}
    </Box>
  );
};

export default ModulesStep;